export const ORDERS_TYPES = {
  NEXT: 'next',
  PREV: 'prev',
};
